export const SALES_TAXES_VALIDATION_RULES = {};



// WEBPACK FOOTER //
// ./src/components/dashboard/sales-taxes/salesTaxesValidationRules.js